<template>
  <div class="">
    <div class="condition clearfix" id="condition">
      <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix" ref="conditions">
        <div class="clearfix" style="margin-bottom: 10px;">
          <!-- search start-->
          <!--  <el-form-item label="盘点单号：" class="tinp">
                    <el-input v-model="conditions.vbillcode" placeholder="请输入申请单号" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
                </el-form-item> -->
          <el-form-item label="盘点日期：" class="tinp searchtime" :class="{iconshow:showicon}">
            <el-date-picker value-format="yyyy-MM-dd" v-model="conditions.time" type="date" placeholder="选择日期"  @mouseover.native="cleandataicon" @mouseout.native="cleandataicon">
            </el-date-picker>
          </el-form-item>
          <!--  <el-form-item label="盘点人：" class="tinp">
                    <el-input v-model="conditions.billmakername" placeholder="请输入申请人" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
                </el-form-item> -->
          <el-button type="primary" class="" size="small" icon="el-icon-search" @click="onParamChange" v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
          <!-- search end icon="el-icon-plus" -->
          <el-button type="primary" class="fr" size="small" @click="addlist">新增盘点单</el-button>
          <el-button type="primary" class="fr" size="small"  @click="exportlist">导出盘点单</el-button>
        </div>
        <!-- tablelist start -->
        <div class="tablebox" style="margin-top: 0px;" v-if="count >=1">
          
          <table style="width:100%;margin-bottom: 16px" v-for="(item,index) in tableList" v-show="item.fbillflag!='1'">
            <tr style="border: 1px solid #56B8AA;background:#fff;color: #333;height:45px">
              <th :id="item.vbillcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(item,index)">
                <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':item.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i></th>
              <th colspan="14">
                <span class="fl tabletitle">门店盘点单号：{{item.vbillcode}}</span>
                <!-- <span class="fl tabletitle">总部盘点单号：{{item.vdef1}}</span> -->
                <span class="fl tabletitle">盘点日期：{{item.dbilldate}}</span>
                <span class="fl tabletitle">盘点货位：{{item.positionname}}</span>
                <!-- <span class="fr tabletitle">盘点人：{{item.billmaker}}</span>  -->
              </th>
            </tr> 
            <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px" v-show="item.listshow =='N'">
              <th style="border: 1px solid #56B8AA;">行号</th>
               <th style="border: 1px solid #56B8AA;" v-for="head in tableHeads2">{{ head.label }}</th> 
            </tr> 
            <tr class="trbg" v-for="(data,index2) in item.productList" :key="item.period" v-show="item.listshow =='N'" v-if="item.fbillflag!='1'">
              <td style="border: 1px solid #56B8AA; height: 38px;">{{index2}}</td>
              <td v-for="head in tableHeads2" style="border: 1px solid #56B8AA; height: 38px;">
                <span>{{data[head.key]}}</span>
              </td> 
            </tr> 
          </table>
          <table style="width:100%;margin-bottom: 16px" v-for="(item,index) in tableList" v-show="item.fbillflag=='1'">
            <tr style="border: 1px solid #56B8AA;background:#fff;color: #333;height:45px">
              <th :id="item.vbillcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(item,index)">
                <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':item.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i></th>
              <th colspan="14">
                <span class="fl tabletitle">门店盘点单号：{{item.vbillcode}}</span>
                <span class="fl tabletitle">总部盘点单号：{{item.vdef1}}</span>
                <span class="fl tabletitle">盘点日期：{{item.dbilldate}}</span>
                <span class="fl tabletitle">盘点货位：{{item.positionname}}</span>
                <!-- <span class="fr tabletitle">盘点人：{{item.billmaker}}</span>  -->
              </th>
            </tr>
            <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px" v-show="item.listshow =='N'" >
              <th style="border: 1px solid #56B8AA;">行号</th>
              <th style="border: 1px solid #56B8AA;" v-for="head in tableHeads">{{ head.label }}</th>  
              <th style="border: 1px solid #56B8AA;" >盘点状态</th>  
              <th style="border: 1px solid #56B8AA;">原因</th>  
            </tr>  
            <tr class="trbg" v-for="(data,index2) in item.productList" :key="item.period" v-show="item.listshow =='N'">
              <td style="border: 1px solid #56B8AA; height: 38px;">{{data.crowno}}</td>
              <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px;">
                <span>{{data[head.key]}}</span> 
              </td> 
              <td style="border: 1px solid #56B8AA; height: 38px;"> 
                <span v-if="data.ndiffastnum>0">盘盈</span>
                <span v-else-if="data.ndiffastnum<0">盘亏</span>
                <span v-else>正确</span>
              </td>  
              <td style="border: 1px solid #56B8AA; height: 38px;"> 
                <span >{{data.vreason}}</span> 
              </td> 
            </tr>
          </table> 
        </div>
        <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
          暂无数据
        </div>
        <!-- tablelist end -->
        <!-- fenye start -->
        <div class="block" style="text-align: center;margin:20px auto ">
          <span>
				    <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
				      :current-page="conditions.page"
				      :page-size="conditions.pagesize"
				      layout="total,  prev, pager, next, jumper"
				      :total="count">
				    </el-pagination>
				    </span>
        </div>
        <!-- fenye end -->
      </el-form>
    </div>
    <!-- model end -->
    <div class="" v-show="fullscreenLoading"  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
    <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
  </div>
</template>
<script> 
// import { getElementsByClassName } from '../../../static/js/cookie.js'
export default {
  name: '',
  data() {
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      InterfacePath: '',
      count: 0,
      id: '',
      index: 0,
      row: 0,
      changebgcolor: -1,
      user: {},
      fullscreenLoading: false,
      showicon: false,
      diaoboshow: false,
      conditions: {
        vbillcode: '', //申请单号
        pk_product: '', //商品名称
        time: '', //申请时间
        billmakername: '', //申请人
        page: 1,
        pagesize: 1,
        count: 0,
      },
      tableList: [],
      tableData: {},
      tableinput: {},
      tableHeads: [
        // {
        //        label: '盘点仓库',
        //        key: 'repertoryname'
        //    },
        {
          label: '盘点货位',
          key: 'positionname'
        },
        {
          label: '商品编码',
          key: 'materialcode'
        },
        {
          label: '商品名称',
          key: 'materialname'
        }, 
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '主单位',
          key: 'cunitname'
        },
        // {
        //     label: '批次号',
        //     key: 'vbatchcode'
        // },
        {
          label: '库存数量',
          key: 'nonhandastnum'
        },
        {
          label: '盘点数量',
          key: 'ncountnum'
        },
        {
          label: '差异数量',
          key: 'ndiffastnum'
        }, 
        // {
        //   label: '盘点状态',
        //   key: 'flag'
        // },
        // // {
        // //     label: '行备注',
        // //     key: 'vnotebody'
        // // },
        // {
        //   label: '原因',
        //   key: 'vreason'
        // }
      ],
      tableHeads2: [ 
        {
          label: '盘点货位',
          key: 'positionname'
        },
        {
          label: '商品',
          key: 'product_name'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '主单位',
          key: 'cunitname'
        },  
        {
          label: '盘点数量',
          key: 'ncountnum'
        },  
        {
          label: '原因',
          key: 'vreason'
        }
      ]
    }
  },
  mounted() {
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
    //console.log("盘点单打印接口路径" + this.InterfacePath);
  },
  destroyed() {
    sessionStorage.removeItem("conditions");
    sessionStorage.removeItem("conditions");
    sessionStorage.removeItem("panlist");
    //console.log("清除session");
  },
  methods: {
  	returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             //console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                //console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了'; 
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow =false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了'; 
                    console.log(err);
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    returnMsg2(flag) {

      this.modelFlag = false;
      
       if (flag) {
        //console.log("---进来了！！！----" + this.methodName);
         
      }
    },
    //显示隐藏表格
    showlist(item, index) {
      //console.log("展开方法");
      this.tableList[index].listshow = item.listshow == 'Y' ? 'N' : 'Y'; 
      this.id = item.vbillcode;
      this.toTop();
      sessionStorage.setItem("panlist", JSON.stringify(this.tableList));

    },
    toTop() {
      var idmsg = '';
      if (this.id != '') {
        idmsg = this.id;
      } else {
        idmsg = 'contain';
      }
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById(idmsg).scrollTop) / 8
      this.step = dis;
      document.getElementById(idmsg).scrollTop -= dis;
      var scroll = document.getElementById(idmsg).scrollTop;
      if (scroll > 0) {
       // console.log("回到顶部循环内" + document.getElementById(idmsg).scrollTop);
        this.step += dis
        var c = setTimeout(() => this.toTop(this.step), 16);
      } else {
        clearTimeout(c);
      }
    },
    changenum() { //实时计算差异数量
      //console.log("index:" + this.row);
      var tnum = this.tableData.tnum;
      if (tnum == '') {
        tnum = 0;
      }
      var num = (parseInt(this.tableData.nznum) - tnum) + '';
      this.tableData.nfnum = num;
      sessionStorage.setItem("tableData", JSON.stringify(this.tableData));
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.conditions.pagesize = val;
       this.page=1; 
      this.getList();
      //console.log(this.pagesize);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.conditions.page = val;
      //console.log(this.page);
      this.getList();
    },
    addlist() {
      this.$router.push({ path: '/ui/stock/pandi/zengpan' });
    },
    exportlist() {
      this.$router.push({path:'/ui/stock/exportlist',query:{pageFlag:0}});
    },
    dellist(index, index2, id) {
      this.$confirm('此操作将永久删除该调整单，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var reqparam = {
          vbillcode: id,
          crowno: index2
        }
        this.$http.post(this.utilpath + '/applybill', reqparam).then((res) => {
          // this.$http.post('api/applybill',reqparam).then((res)=>{
          // this.$http.post('ktnapi/insertPrabill',reqparam,{emulateJSON:true}).then((res)=>{
          if (res.data.status == '0') {
            this.tableList[index].productList.splice(index2, 1);
            sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));
            this.count = this.tableList.length;
            this.$message({
              showClose: true,
              message: '删除成功！',
              type: 'succcess'
            });
          } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.$message({
              showClose: true,
              message: '删除失败!',
              type: 'error'
            });
          }
        }, (err) => {
          this.$message({
            showClose: true,
            message: '命令提交失败!',
            type: 'error'
          });
          console.log(err);
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    cleandataicon() {
      // console.log("划过");
      if (this.conditions.time != '') {
        this.showicon = !this.showicon;
      }
      if (this.conditions.time == null) {
        this.showicon = false;
      }
    },
    //获取数据
    getList() {
      this.fullscreenLoading = true;
      var reqParam = this.conditions
      sessionStorage.setItem("conditions", JSON.stringify(reqParam));
     //console.log("调用de接口" + this.InterfacePath);
      //搜索参数
      var reqparam = {
        storecode: this.user.storecode, //门店编码 
        time: this.conditions.time, //日期 
        pageNum: this.conditions.page,
        pageSize: this.conditions.pagesize,
      };
      //console.log("打印参数："+JSON.stringify(reqparam));
      //获取数据接口
      // this.$post("/selectPresentSock",reqparam,{emulateJSON:true})
      this.$http.post(this.utilpath + '/selectInvcount', reqparam, { emulateJSON: true,_timeout:600 })
        // this.$http.post("/ktnapi/selectInvcount",reqparam,{emulateJSON:true})
        // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true}) 
        .then((res) => {
          if (res.data.status == '0') {
            this.fullscreenLoading = false;
            // this.tableList=res.data.result;
            this.tableList = res.data.resultList;
            this.count = res.data.countNum;
            //console.log("打印数据："+JSON.stringify(this.tableList));
            sessionStorage.setItem("panlist", JSON.stringify(this.tableList));
          } else if (res.data.status == '-1') {
            this.fullscreenLoading = false;
            this.tableList = [];
            this.count = 0;
            this.$message({
              showClose:true,
              message:'暂无数据',
              type:'info'
            });
          } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else{
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了';
          }
          // console.log("获取数据长度："+this.tableList.length);
          //console.log("获取数据："+JSON.stringify(this.tableList.productList));
          // console.log("获取的JSON数据"+JSON.stringify(res.result));       
        }, (err) => {
          this.fullscreenLoading = false;
          this.msgShow =false;
          this.modelFlag = true;
          this.methodName = 'message';
          this.msg = '连接获取盘点单接口失败'+err;
          this.butflag =false;
          this.butmsg='知道了';
          //console.log(err);
        });
    }, 
    changerpwcolor(index) {
      this.changebgcolor = index;
    },
    init() {
      //sessionStorage.removeItem("weilist");
      this.user = JSON.parse(window.localStorage.getItem("userInfo"));
      var show = sessionStorage.getItem("diaoboshow");
      if (show != null) {
        this.diaoboshow = show;
        this.tableData = JSON.parse(sessionStorage.getItem("tableData"));
        this.tableinput = JSON.parse(sessionStorage.getItem("tableinput"));
      }
      var bigdata = JSON.parse(sessionStorage.getItem("panlist"));
      // if (bigdata != null) {
      //   console.log("打印bigdata"+JSON.stringify(bigdata))
      //   this.tableList = bigdata;
      //   this.conditions = JSON.parse(sessionStorage.getItem("conditions"));
      //   this.count = this.tableList.length;
      //   this.fullscreenLoading=false;
      // } else {
        // this.getList();
      // }
    },
    modify(index, index2, id) {
      this.id = id;
      this.index = index;
      this.row = index2;
      this.tableData = this.tableList[index].productList[index2];
      sessionStorage.setItem("tableData", JSON.stringify(this.tableData));
      this.tableinput = this.tableList[index];
      sessionStorage.setItem("tableinput", JSON.stringify(this.tableinput));
      this.tableinput.modifiedtime = '';
      this.diaoboshow = true;
      sessionStorage.setItem("diaoboshow", true);
    },
    closemodel() {
      this.diaoboshow = false;
      sessionStorage.removeItem("diaoboshow");
      sessionStorage.removeItem("tableinput");
      sessionStorage.removeItem("tableData");
      this.tableData = {};
      this.tableinput = {};
    },
    sumbittable() {
      var reqParam = {
        vbillcode: this.id,
        crowno: this.row,
        tableinput: this.tableinput,
        tnum: this.tableData.tnum
      };
      this.$http.post(this.utilpath + '/goods', reqParam).then((res) => {
        // this.$http.post("api/goods",reqParam).then((res)=>{
        // this.$http.post('ktnapi/insertPrabill',reqparam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          this.getList();
          this.diaoboshow = false;
          this.$message({
            showClose: true,
            type: 'succcess',
            message: '修改成功'
          })
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: '修改失败'
          })
        }
      }, (err) => {
        console.log(err);
        this.$message({
          showClose: true,
          type: 'error',
          message: '修改数据提交失败'
        })
      });
      //   	this.tableData = {};
      // this.tableinput ={};
    },
    onchange() {
      sessionStorage.setItem("tableinput", this.tableinput);

      //console.log("打印时间" + this.tableinput.modifiedtime);
    },
    //搜索框变化事件
    onParamChange() {
      this.page = 1;
      this.getList();
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stock/pan2.vue